module.exports = __webpack_public_path__ + "static/media/recpie3.b348b581.png";